var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearchClear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#D2D4E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5156 8.03906L11.0547 10.5L13.5156 12.9844C13.8203 13.2656 13.8203 13.7578 13.5156 14.0391C13.2344 14.3438 12.7422 14.3438 12.4609 14.0391L10 11.5781L7.51562 14.0391C7.23438 14.3438 6.74219 14.3438 6.46094 14.0391C6.15625 13.7578 6.15625 13.2656 6.46094 12.9844L8.92188 10.5L6.46094 8.03906C6.15625 7.75781 6.15625 7.26562 6.46094 6.98438C6.74219 6.67969 7.23438 6.67969 7.51562 6.98438L10 9.44531L12.4609 6.98438C12.7422 6.67969 13.2344 6.67969 13.5156 6.98438C13.8203 7.26562 13.8203 7.75781 13.5156 8.03906Z",
    fill: "url(#paint0_linear_2985_73040)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2985_73040",
    x1: 1.5,
    y1: 2,
    x2: 17,
    y2: 17.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.411458,
    stopColor: "#0D0C13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0EFF5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearchClear);
export default __webpack_public_path__ + "static/media/icon-search-clear.dac3ad4c707aa6bd6f978fb14fa80fcc.svg";
export { ForwardRef as ReactComponent };